import { Edit } from "@refinedev/antd";
import { Drawer, DrawerProps, Form, FormProps, Input, ButtonProps } from "antd";

type EditWorkItemProps = {
    drawerProps: DrawerProps;
    formProps: FormProps;
    saveButtonProps: ButtonProps;
};

export const EditWorkItem: React.FC<EditWorkItemProps> = ({
    drawerProps,
    formProps,
    saveButtonProps,
}) => {

    return (
        <Drawer
            {...drawerProps}
            width="500"
        >
            <Edit resource="work_items" saveButtonProps={saveButtonProps} title="Edit Item">
                <Form
                    {...formProps}
                    layout="vertical"
                >

                    <Form.Item
                        label="Code"
                        name="code"
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="work_id"
                        hidden={true}
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                </Form>
            </Edit>

        </Drawer>
    );
};